import { useSetAtom } from 'jotai';

import {
  conversationHistoryAtom,
  deleteConversation as deleteConversationFromHistory,
} from '../../state';

import { pinnedConversationsAtom, renamingConversationIdAtom } from './state';

export const useHistoryItemActions = (conversationId: string) => {
  const setPinnedConversations = useSetAtom(pinnedConversationsAtom);
  const setHistory = useSetAtom(conversationHistoryAtom);
  const setRenamingConversationId = useSetAtom(renamingConversationIdAtom);

  const handlePinConversation = () => {
    setPinnedConversations(pinnedConversations => [
      ...pinnedConversations,
      { conversationId, order: pinnedConversations.length },
    ]);
  };

  const handleUnpinConversation = () => {
    setPinnedConversations(pinnedConversations =>
      pinnedConversations.filter(
        pinnedConversation =>
          pinnedConversation.conversationId !== conversationId,
      ),
    );
  };

  const handleRenameConversation = () => {
    setRenamingConversationId(conversationId);
  };

  const handleDeleteConversation = () => {
    setPinnedConversations(pinnedConversations =>
      pinnedConversations.filter(
        pinnedConversation =>
          pinnedConversation.conversationId !== conversationId,
      ),
    );
    setHistory(history =>
      history.filter(conversation => conversation.id !== conversationId),
    );
  };

  return {
    handlePinConversation,
    handleRenameConversation,
    handleUnpinConversation,
    handleDeleteConversation,
  };
};

export { deleteConversationFromHistory };
